var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5888 1.2741C19.225 1.8308 19.3841 3.1827 19.3841 3.1827C19.3841 3.1827 19.5431 4.6937 19.5431 6.2047V7.6362C19.5431 9.2267 19.3841 10.7376 19.3841 10.7376C19.3841 10.7376 19.1455 12.0896 18.5888 12.6463C17.9867 13.2483 17.3283 13.3439 16.8977 13.4065C16.8165 13.4183 16.7433 13.4289 16.6802 13.4415C13.9763 13.6801 10.0001 13.6801 10.0001 13.6801C10.0001 13.6801 4.99003 13.6801 3.47903 13.521C3.40273 13.5058 3.30603 13.4964 3.19433 13.4855C2.72403 13.4398 1.98983 13.3685 1.41133 12.7258C0.775131 12.1691 0.616132 10.8172 0.616132 10.8172C0.616132 10.8172 0.457031 9.2267 0.457031 7.7157V6.2842C0.457031 4.6937 0.616132 3.1827 0.616132 3.1827C0.616132 3.1827 0.854731 1.8308 1.41133 1.2741C2.01343 0.672001 2.67183 0.576401 3.10243 0.513901C3.18373 0.502101 3.25683 0.491501 3.31993 0.478901C6.02383 0.319801 10.0001 0.319801 10.0001 0.319801C10.0001 0.319801 13.9763 0.319801 16.6802 0.478901C17.0778 0.478901 17.8731 0.478901 18.5888 1.2741ZM8.01203 4.1371V9.4653L13.1811 6.8409L8.01203 4.1371Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.a78527c8.svg";
export { ForwardRef as ReactComponent };